/**
 * A money cell a viewer cannot see (DP-01, `webapi/redact.py`): the dash,
 * same as any other missing value, but with a tooltip saying *why* it is
 * missing rather than leaving it looking like there is simply no amount.
 *
 * Same component as the one `pages/Customers.tsx` defines locally for budget
 * amounts — pulled out here so the replacement-planning screens (the plan
 * list, the plan editor's grid and totals card) can share it rather than
 * growing a third copy of the same tooltip.
 */
import { Text, Tooltip } from '@mantine/core'

import { EM_DASH } from '../format'

export function HiddenAmount() {
  return (
    <Tooltip label="מוצג למנהלים ולעורכים בלבד">
      <Text span c="dimmed" style={{ cursor: 'help' }}>{EM_DASH}</Text>
    </Tooltip>
  )
}
